<template>
    <div class="header">
        <img src="../assets/images/login/logo.png" style="float: left;max-width: 95px;max-height: 76px;padding-top: 20px;margin-left: 240px">
        <!--<ul class="menus" style="min-width: 900px;">-->
            <!--<li ><a href="/homes">首页</a></li>-->
            <!--<li >-->
              <!--<p style="display: inline-block;width: 120px">-->
                <!--<a>产品</a>-->

              <!--</p>-->
                <!--<ul style=";margin-left: 50px;position: absolute;background-color: #fff;display: block;margin-top:-0.5rem">-->
                    <!--<li style="line-height: 30px"><a href="/product" style="color: #333333;font-size: 18px;line-height: 30px">资料分类</a></li>-->
                    <!--<li style="line-height: 30px"><a href="/detaile" style="color: #333333;font-size: 18px;line-height: 30px">产品详情</a></li>-->
                <!--</ul>-->
            <!--</li>-->

            <!--<li>-->
                <!--<a>工具与资料</a>-->
                <!--<ul style="display: none">-->
                    <!--<li>资料分类</li>-->
                <!--</ul>-->
            <!--</li>-->

            <!--<li>-->
                <!--<a>新闻</a>-->
                <!--<ul style="display: none">-->
                    <!--<li>信息更新</li>-->
                <!--</ul>-->
            <!--</li>-->

            <!--<li>-->
                <!--<a>关于中颖</a>-->
                <!--<ul style="display: none">-->
                    <!--<li>关于中颖</li>-->
                    <!--<li>中颖大记事</li>-->
                    <!--<li>招聘</li>-->
                    <!--<li>联系我们</li>-->
                <!--</ul>-->
            <!--</li>-->

            <!--<li>-->
                <!--<a>投资者关系</a>-->
                <!--<ul style="display: none">-->
                    <!--<li>经销商关系</li>-->
                <!--</ul>-->
            <!--</li>-->

            <!--<li style="margin-left: 40px">-->
                <!--<el-input class="menus-search" placeholder="请输入内容" style="width: 373px;">-->
                    <!--<el-select></el-select>-->
                    <!--<el-button slot="append" icon="el-icon-search" size="small" ></el-button>-->
                <!--</el-input>-->
            <!--</li>-->

            <!--<li>-->
                <!--<a href="/login" style="font-size: 16px;color: #4A90E2">登录</a>-->
                <!--<span style="color: #4A90E2;">|</span>-->
                <!--<a href="/register" style="font-size: 16px;margin-left: 0;color: #4A90E2">注册</a>-->
            <!--</li>-->
        <!--</ul>-->

  <div class="menus" style="min-width: 1500px">
      <div class="menus-content">
          <el-menu  class="el-menu-demo" mode="horizontal" @select="handleSelect" >
            <el-menu-item index="1"><a href="/home">首页</a></el-menu-item>

            <el-submenu index="2">
                <template slot="title">产品</template>
                <el-menu-item index="2-1">
                    <a href="/product"  style="font-size: 16px;color: rgba(51,51,51,1);margin-left: 10px">资料分类</a>
                </el-menu-item>

                <el-menu-item index="2-2">
                   <a href="/detaile"  style="font-size: 16px;color: rgba(51,51,51,1);margin-left: 10px">产品详情</a>
                </el-menu-item>
            </el-submenu>

            <el-menu-item index="1"><a href="/tools">工具与资料</a></el-menu-item>

            <el-submenu index="4">
                <template slot="title">新闻</template>
                <el-menu-item index="4-1">
                    <a href="/news"  style="font-size: 16px;color: rgba(51,51,51,1);margin-left: 10px">信息更新</a>
                </el-menu-item>
                <el-menu-item index="4-1">
                    <a href="/article"  style="font-size: 16px;color: rgba(51,51,51,1);margin-left: 10px">知识文章</a>
                </el-menu-item>
            </el-submenu>

            <el-submenu index="5">
                <template slot="title">关于中颖</template>
                <el-menu-item index="5-1">
                    <a href="/about"  style="font-size: 16px;color: rgba(51,51,51,1);margin-left: 10px">企业简介</a>
                </el-menu-item>
                <el-menu-item index="5-2">
                    <a href="/event"  style="font-size: 16px;color: rgba(51,51,51,1);margin-left: 10px">中颖大记事</a>
                </el-menu-item>
                <el-menu-item index="5-3">
                    <a href="/dealer"  style="font-size: 16px;color: rgba(51,51,51,1);margin-left: 10px">经销商信息</a>
                </el-menu-item>
                <el-menu-item index="5-4">
                    <a href="/contact"  style="font-size: 16px;color: rgba(51,51,51,1);margin-left: 10px">联系我们</a>
                </el-menu-item>
            </el-submenu>

            <el-menu-item index="6"><a href="/partner">投资者关系</a></el-menu-item>
          </el-menu>
      </div>

      <div style="padding-top: 20px;">
          <ul >
              <li style="margin-left: 40px;display: inline">
                  <el-input class="menus-search" placeholder="请输入内容" style="width: 320px;">
                  <el-select></el-select>
                  <el-button slot="append" icon="el-icon-search" size="small" ></el-button>
                  </el-input>
              </li>

              <li style="display: inline">
                  <a href="/login" style="font-size: 16px;color: #4A90E2">登录</a>
                  <span style="color: #4A90E2;">|</span>
                  <a href="/register" style="font-size: 16px;margin-left: 0;color: #4A90E2">注册</a>
              </li>
          </ul>
      </div>
  </div>
</div>
</template>

<script>
  export default {
    name: "header",
    data() {
      return{}
    },
    methods: {
      handleSelect(key, keyPath) {
        console.log(key, keyPath);
      }
    }
  }
</script>

<style>
  .header { background-color: #ffffff;min-width: 900px;position: fixed;display: block;}
  /*.header .menus  { list-style:none;text-align: center;padding-top: 20px }*/
  /*.header > ul > li > a {  font-size: 24px;color: #333333;margin-left: 40px;cursor: pointer}*/
  /*.header .menus > li  {  position: relative;vertical-align: top;display: inline;width:120px;height:88px}*/
  /*.header .login-register > a { text-decoration: none;font-size: 12px;color: #4A90E2; }*/
  /*.header li { width: 72px }*/
  /*.header >* { display: inline-block;line-height: 80px;vertical-align: middle }*/
  .header .el-menu-demo a { font-size: 24px;color: rgba(51,51,51,1); }
  .header .el-menu--horizontal>.el-submenu .el-submenu__title { font-size: 24px;color: rgba(51,51,51,1); }
  .header .menus .sub-menu > a { font-size: 16px;color: rgba(51,51,51,1); margin-left: 10px}
  .header .menus .menus-content {padding-top: 20px;margin-left: 60px;float: left }
</style>



// WEBPACK FOOTER //
// src/pages/header.vue